// extracted by mini-css-extract-plugin
export default {"root":"ImageUploaderTabs_root__VJIFV"};